import SimpleBar from 'simplebar-react'
import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useFlag } from '@calendly/feature-check-react'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue700))'
const fontWeightSemibold = 'var(--fontWeightSemibold, 600)'
import { Link } from '@calendly/ui/components/link'
import { OnetrustSettingsButton } from '@calendly/onetrust/redux'

import { useI18n } from 'locales'
import { BookingRedesignLegalFooter } from 'components/layout/booking_redesign_legal_footer'
import _Panel from "side_panel-Panel.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/layout/side_panel.js?styleId=Panel";
import _Container from "side_panel-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/layout/side_panel.js?styleId=Container";
import _CookieSettingsButton from "side_panel-CookieSettingsButton.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/layout/side_panel.js?styleId=CookieSettingsButton";
import _ScrollContainer from "side_panel-ScrollContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/layout/side_panel.js?styleId=ScrollContainer";
import _InnerPaddingContainer from "side_panel-InnerPaddingContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/layout/side_panel.js?styleId=InnerPaddingContainer";
import _StyledInline from "side_panel-StyledInline.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/layout/side_panel.js?styleId=StyledInline";
import _StyledLink from "side_panel-StyledLink.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/layout/side_panel.js?styleId=StyledLink";
import _RedesignFooterWrap from "side_panel-RedesignFooterWrap.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/layout/side_panel.js?styleId=RedesignFooterWrap";


const Panel = /*#__PURE__*/styled('div', null, {
  displayName: "Panel",
  styles: _Panel,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown'),
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const CookieSettingsButton = /*#__PURE__*/styled(OnetrustSettingsButton, null, {
  displayName: "CookieSettingsButton",
  styles: _CookieSettingsButton
})

const ScrollContainer = /*#__PURE__*/styled('div', null, {
  displayName: "ScrollContainer",
  styles: _ScrollContainer,
  attrs: props => ({
    ...props,
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

const InnerPaddingContainer = /*#__PURE__*/styled('div', null, {
  displayName: "InnerPaddingContainer",
  styles: _InnerPaddingContainer,
  attrs: props => ({
    ...props,
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

const StyledInline = /*#__PURE__*/styled('span', null, {
  displayName: "StyledInline",
  styles: _StyledInline
})

const StyledLink = /*#__PURE__*/styled(Link, null, {
  displayName: "StyledLink",
  styles: _StyledLink
})

const RedesignFooterWrap = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignFooterWrap",
  styles: _RedesignFooterWrap
})

const FooterLinks = () => {
  const { i18n } = useI18n()

  return (
    <StyledInline>
      <CookieSettingsButton />
      <StyledLink
        underline={false}
        href="https://calendly.com/legal/privacy-notice"
        target="_blank"
        rel="noopener noreferrer"
      >
        {`${i18n.t('booking.terms_and_conditions.privacy_policy')}`}
      </StyledLink>
    </StyledInline>
  )
}

const SidePanel = ({ children, ...props }) => {
  const isDesktopUp = useDeviceType('isDesktopUp')
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const showRedesignLegalFooterInSidebar = bookingAppRedesign && isDesktopUp

  return (
    <Panel {...props} data-container="side-panel">
      <Container>
        <ScrollContainer as={SimpleBar} scrollableNodeProps={{ tabIndex: 0 }}>
          <InnerPaddingContainer>
            {children}
          </InnerPaddingContainer>
        </ScrollContainer>
        {showRedesignLegalFooterInSidebar ? (
          <RedesignFooterWrap>
            <BookingRedesignLegalFooter />
          </RedesignFooterWrap>
        ) : (
          isDesktopUp && (<FooterLinks />)
        )}
      </Container>
    </Panel>
  )
}

export default SidePanel
